var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_33)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0B5351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2222 21.0465V25C13.2222 25.5523 12.7745 26 12.2222 26H9.87037C9.31809 26 8.87037 25.5523 8.87037 25V16.8892C8.87037 16.4238 8.4931 16.0465 8.02771 16.0465C7.27792 16.0465 6.90153 15.1408 7.43048 14.6094L15.2994 6.7039C15.6871 6.31437 16.3165 6.31075 16.7087 6.6958L19.3727 9.31138C19.6336 9.56752 20.0741 9.3827 20.0741 9.01708C20.0741 8.7893 20.2587 8.60465 20.4865 8.60465H21.4815C22.0338 8.60465 22.4815 9.05237 22.4815 9.60465V11.9276C22.4815 12.1832 22.5793 12.429 22.7549 12.6147L24.5771 14.5417C25.1148 15.1104 24.7117 16.0465 23.929 16.0465C23.4364 16.0465 23.037 16.4459 23.037 16.9385V25C23.037 25.5523 22.5893 26 22.037 26H19.5926C19.0403 26 18.5926 25.5523 18.5926 25V21.0465C18.5926 20.4942 18.1449 20.0465 17.5926 20.0465H14.2222C13.6699 20.0465 13.2222 20.4942 13.2222 21.0465Z",
    fill: "#00A9A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.551e297eb1f67bd13abe3ad171721864.svg";
export { ForwardRef as ReactComponent };